<template>
  <div class="development-history">
    <div class="history-content">
      <div class="title">{{ title }}</div>
      <div class="describe">{{ describe }}</div>
      <div class="history-list">
        <div class="swiper-box">
          <swiper ref="swiper" class="swiper" :options="swiperOption">
            <swiper-slide v-for="(item, index) in historyList" :key="index">
              <div class="history-item">
                <div class="separate-line">
                  <div class="circular"></div>
                  <div class="line"></div>
                </div>
                <div class="item-content">
                  <div class="event-list">
                    <div
                      v-for="(eventItem, eventIndex) in item.history"
                      :key="eventIndex"
                      class="event-item"
                    >
                      {{ eventItem }}
                    </div>
                  </div>
                  <div class="event-year">
                    {{ item.year }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div slot="button-prev" class="swiper-button-prev"></div>
        <div slot="button-next" class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'HistoryView',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      title: '',
      describe: '',
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // on: {
        //   resize: () => {
        //     this.$refs.swiper.
        //   },
        // },
      },
      historyList: [
        // {
        //   year: '2008',
        //   history: [
        //     '公司成立华跃eHR V2008系统获得国家软件著作权认证',
        //   ],
        // },
        // {
        //   year: '2009',
        //   history: [
        //     '顺德区政府创新基金重点扶持单位',
        //   ],
        // },
        // {
        //   year: '2010',
        //   history: [
        //     '华跃eHR V2008获评行业“最具创新HR软件产品”',
        //   ],
        // },
        // {
        //   year: '2011',
        //   history: [
        //     '活跃eHR移动平台V1.0正式上线',
        //   ],
        // },
        // {
        //   year: '2012',
        //   history: [
        //     '顺德区“星光工程”重点扶持企业',
        //   ],
        // },
        // {
        //   year: '2013',
        //   history: [
        //     '获评顺德区RFID项目政府创新扶持资金重点项目',
        //   ],
        // },
        // {
        //   year: '2014',
        //   history: [
        //     '通过国家高新技术企业审核',
        //   ],
        // },
        // {
        //   year: '2015',
        //   history: [
        //     '活跃经典eHR V3.0系统正式退出，成为区高新技术企业重点培育单位',
        //   ],
        // },
        // {
        //   year: '2016',
        //   history: [
        //     '获评广东省高新技术企业',
        //     '“重合同守信用”示范单位',
        //     '软件信息服务产业杰出贡献奖',
        //   ],
        // },
        // {
        //   year: '2017',
        //   history: [
        //     '获评高新技术产业创新贡献奖',
        //     '软件信息服务产业优秀服务企业奖',
        //   ],
        // },
        // {
        //   year: '2018',
        //   history: [
        //     '华跃eHR移动平台V3.0正式上线',
        //   ],
        // },
        // {
        //   year: '2019',
        //   history: [
        //     '推出华跃eHRV6.0系统eHR自助服务V1.0',
        //     '活跃移动3eHR V3.0获高新技术产品认证',
        //   ],
        // },
        // {
        //   year: '2020',
        //   history: [
        //     '推出DHCP云平台高新技术企业证书',
        //     '通过ISO9001认证入库佛山资源池',
        //   ],
        // },
        // {
        //   year: '2021',
        //   history: [
        //     '通过ISO27001认证顺德区工业企业上云上平台应用产品目录',
        //   ],
        // },
      ],
    };
  },
  mounted() {
    this.getPageColumn();
  },
  methods: {
    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1608278582608748544', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (i === 0) {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var describe = rrsult.elements.find(obj => obj.name === 'describe').content;
              this.title = rrsult.name;
              this.describe = describe;
            });
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var historyItem = {
                  year: rrsult.data[j].title,
                  history: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  historyItem.history.push(rtsult.elements[x].content);
                }
                this.historyList.push(historyItem);
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.development-history{
  width: 100%;
  min-width: 1245px;
  height: 750px;
  background: url('@/assets/about/history/canvas.png') no-repeat;
  background-size: cover;
  background-position: center;
  .history-content{
    width: 1245px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 65px;
    box-sizing: border-box;
    .title{
      font-family: OPPOSans-M;
      font-size: 34px;
      color: #1c1c1c;
      line-height: 1;
      margin-bottom: 20px;
    }
    .describe{
      font-family: OPPOSans-R;
      font-size: 16px;
      color: #1c1c1c;
      line-height: 1;
      margin-bottom: 40px;
    }
    .history-list{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .swiper-box{
        width: 1150px;
        ::v-deep .swiper-container{
          height: 350px;
          .swiper-wrapper{
            align-items: flex-end;
            .swiper-slide{
              height: auto;
            }
          }
        }
        .history-item{
          flex: 1;
          display: flex;
          .separate-line{
            width: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin-right: 16px;
            .circular{
              width: 15px;
              height: 16px;
              border: 3px solid #00b0dc;
              border-radius: 50%;
              opacity: 0.37;
              box-sizing: border-box;
              transition: opacity .3s ease-in-out;
            }
            .line{
              width: 3px;
              height: 100%;
              background-color: #00b0dc;
              opacity: 0.37;
              transition: opacity .3s ease-in-out;
            }
          }
          .item-content{
            padding-top: 5px;
            padding-bottom: 39px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .event-list{
              width: 100%;
              .event-item{
                font-size: 16px;
                color: #181818;
                opacity: 0.37;
                margin-bottom: 25px;
                transition: opacity .3s ease-in-out;
              }
            }
            .event-year{
              margin-top: 17px;
              font-size: 40px;
              font-family: OPPOSans-M;
              color: #00b0dc;
              opacity: 0.37;
              line-height: 0.9;
              transition: all .3s ease-in-out;
            }
          }
        }
        .history-item:hover{
          .separate-line{
            .circular{
              opacity: 1;
            }
            .line{
              opacity: 1;
            }
          }
          .item-content{
            .event-list{
              .event-item{
                opacity: 1;
              }
            }
            .event-year{
              margin-top: 37px;
              opacity: 1;
            }
          }
        }
      }
      .swiper-button-prev{
        width: 45px;
        height: 45px;
        background: url('@/assets/about/history/prev-button.png') no-repeat;
        background-size: cover;
        background-position: center;
        margin-top: 0;
        left: 0;
        top: 240px;
        &::after{
          content: '';
        }
      }
      .swiper-button-next{
        width: 45px;
        height: 45px;
        background: url('@/assets/about/history/nest-button.png') no-repeat;
        background-size: cover;
        background-position: center;
        margin-top: 0;
        right: 0;
        top: 240px;
        &::after{
          content: '';
        }
      }
    }
  }
}
</style>
